import React from "react";
import { useObserver } from "mobx-react";
import { Checkbox, FormControlLabel, Paper, Table } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import locale from "@bonliva-crm/locale";
import {
  AccountMultipleCheck,
  ContentSave,
  FileUpload,
  Information
} from "mdi-material-ui";
import { Body, PrimaryButton, SecondaryButton } from "@components";
import { EnhancedTableHead } from "./EnhancedTableHead";
import { ConsultantImportStore } from "../ConsultantImportStore";
import { ConsultantTableBody } from "./ConsultantTableBody";
import { ThemeType } from "@theme";

type Props = {
  store: ConsultantImportStore;
};

export function UploadResult(props: Props) {
  const classes = useStyles({});
  const { store } = props;

  return useObserver(() => (
    <div className={classes.root}>
      <Paper className={classes.actions}>
        <div className={classes.actionsRow}>
          <Information fontSize="small" />

          {store.data.length === 0 && <Body>{locale.NothingToImport}</Body>}

          {!store.isDeduped && store.errors.length === 0 && store.data.length > 0 && (
            <Body>{locale.RunDedupeToProceed}</Body>
          )}

          {store.errors.length > 0 && (
            <Body>{locale.FixErrorsAndReupload(store.errors.length)}</Body>
          )}

          {store.isDeduped && store.errors.length === 0 && store.validRows.length > 0 && (
            <Body>{locale.PressSaveToImport(store.validRows.length)}</Body>
          )}

          <SecondaryButton
            loading={store.isDeduping}
            disabled={store.isDeduped || store.isDeduping || store.data.length === 0}
            onClick={store.dedupeRows}
            leftIcon={<AccountMultipleCheck fontSize="small" />}
            style={{ marginLeft: "auto" }}
          >
            {locale.CheckForDupes}
          </SecondaryButton>

          {/*<SecondaryButton*/}
          {/*  loading={store.isLookingup}*/}
          {/*  disabled={store.isLookingup || store.data.length === 0}*/}
          {/*  leftIcon={<AccountSearch fontSize="small" />}*/}
          {/*>*/}
          {/*  {locale.BiznodeLookup}*/}
          {/*</SecondaryButton>*/}

          <SecondaryButton
            leftIcon={<FileUpload fontSize="small" />}
            onClick={store.reselectFile}
          >
            {locale.ReuploadFile}
          </SecondaryButton>

          <PrimaryButton
            color="primary"
            leftIcon={<ContentSave fontSize="small" />}
            onClick={store.saveSelected}
            disabled={!store.canSubmit}
          >
            {locale.Save}
          </PrimaryButton>
        </div>

        <div className={classes.checkboxRow}>
          <FormControlLabel
            control={
              <Checkbox
                checked={store.withLookup}
                onChange={(e, v) => (store.withLookup = v)}
              />
            }
            label={locale.ImportWithBiznode}
            style={{ marginLeft: "auto" }}
          />
        </div>
      </Paper>

      <Paper className={classes.results}>
        <Table className={classes.table}>
          <EnhancedTableHead />
          <ConsultantTableBody store={store} />
        </Table>
      </Paper>
    </div>
  ));
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    padding: 16
  },

  actions: {
    padding: 16,
    marginBottom: 16
  },

  actionsRow: {
    ...theme.mixins.childrenMarginRight(8),
    alignItems: "center",
    display: "flex"
  },

  checkboxRow: {
    ...theme.mixins.childrenMarginRight(24),
    alignItems: "center",
    display: "flex"
  },

  results: {
    padding: 0
  },

  table: {
    "& thead tr": { height: "48px !important" },
    "& td, & th": { padding: "8px 16px !important" }
  }
}));
